import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';

export function linkedInValidator(): ValidatorFn {
  return (control: AbstractControl): Record<string, boolean> | null => {
    if (!control.value) {
      return null;
    }
    return Validators.pattern(
      /((https?:\/\/)?((www|\w\w)\.)?linkedin\.com\/)((([\w]{2,3})?)|([^/]+\/(([\w|\d-&#?=])+\/?){1,}))$/
    )(control);
  };
}

export function urlValidator(): ValidatorFn {
  return (control: AbstractControl): Record<string, string> | null => {
    if (!control.value) {
      return null;
    }
    if (URLIsDefinedInBrowser()) {
      try {
        new URL(control.value);
        return null;
      } catch {
        return { invalidUrl: `${control.value} is not a valid url` };
      }
    } else {
      return Validators.pattern(
        /^[A-Za-z][A-Za-z\d.+-]*:\/*(?:\w+(?::\w+)?@)?[^\s/]+(?::\d+)?(?:\/[\w#!:.?+=&%@\-/]*)?$/
      )(control);
    }
  };
}

function URLIsDefinedInBrowser(): boolean {
  try {
    if (typeof URL === 'undefined') {
      return false;
    }
    new URL('https://example.com');
    return true;
  } catch {
    return false;
  }
}
